import { Resource as e } from "@coveo/platform-client";
// src/resources/PreviewResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/v3/analysis/preview";
	}
	pipelinePreview(e, n) {
		return this.api.post(this.buildPath(`${t.baseUrl}/pipelines/${e}`, { organizationId: this.api.organizationId }), n);
	}
};
export { t as PreviewResource };

//# sourceMappingURL=PreviewResource.js.map